

<template functional>
  <footer style="background:white;padding:20px 10px 5px 10px;text-align:center">

    <h2 style="text-decoration:underline;font-family: 'Piedra', cursive;">
      PARTNERS
    </h2>
    <span>
    <p style="padding-top:10px;">
      <span style="font-size:20px;font-family: 'Chewy', cursive;font-weight:bold">#WhiteKnight Project</span>
      is brought to you jointly by
    </p>
    </span>
      <img src="@/assets/images/dacsee.jpg" class='imagefooter'/>
      <img src="@/assets/images/worldpos.jpg" class='imagefooter'/>
    <img src="@/assets/images/connects.jpg" class='imagefooter' />
  </footer>

</template>

<script>
export default {
  name: "the-footer",
  props: {
    classes: {
      type: String
    }
  }
};
</script>
